import type { UseQueryResult } from '@tanstack/react-query';
import { useBffGet } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import type { BloomreachWidget } from './model/BloomreachWidget';

export const useAllWidgets = (): UseQueryResult<BloomreachWidget[], unknown> => {
    const keys = [BffQueryKey.BLOOMREACH_WIDGETS];
    return useBffGet<BloomreachWidget[]>('bloomreach/widgets', undefined, keys, {
        staleTime: 0,
        cacheTime: 0,
        retryOnMount: true,
        refetchOnWindowFocus: false,
    });
};
